import type { ListingDetailsImagesInner } from './ListingDetailsImagesInner';
import type { ListingStatus } from './ListingStatus';
import type { PropertyTypeID } from './PropertyTypeID';

/**
 *
 */
export interface ListingDetails {
  /**
   *
   */
  listingId: number;
  /**
   *
   */
  listingTypeId: PropertyTypeID;
  /**
   *
   */
  description: string;
  /**
   *
   */
  salePrice: string;
  /**
   *
   */
  salePriceUnit: string;
  /**
   *
   */
  negotiable: boolean;
  /**
   *
   */
  transactionType?: ListingDetailsTransactionTypeEnum;
  /**
   *
   */
  ownershipType?: ListingDetailsOwnershipTypeEnum;
  /**
   *
   */
  facingDirection?: ListingDetailsFacingDirectionEnum;
  /**
   *
   */
  plotArea?: number | null;
  /**
   *
   */
  plotAreaUnit?: string | null;
  /**
   *
   */
  hasBoundaryWall: boolean;
  /**
   *
   */
  approvedAuthority?: string | null;
  /**
   *
   */
  lengthOfPlot?: string | null;
  /**
   *
   */
  breathOfPlot?: string | null;
  /**
   *
   */
  soilType?: string | null;
  /**
   *
   */
  irrigationSource?: string | null;
  /**
   *
   */
  carpetArea?: number | null;
  /**
   *
   */
  carpetAreaUnit?: string | null;
  /**
   *
   */
  builtUpArea?: number | null;
  /**
   *
   */
  builtUpAreaUnit?: string | null;
  /**
   *
   */
  numOfBedrooms?: number | null;
  /**
   *
   */
  numOfBathrooms?: number | null;
  /**
   *
   */
  numOfBalconies?: number | null;
  /**
   *
   */
  floorCount?: number | null;
  /**
   *
   */
  parkingSpaces?: string | null;
  /**
   *
   */
  propertyAge?: number | null;
  /**
   *
   */
  distanceToMainRoad?: number | null;
  /**
   *
   */
  distanceToSchool?: number | null;
  /**
   *
   */
  distanceToHospital?: number | null;
  /**
   *
   */
  areaOrLandmark?: string | null;
  /**
   * YouTube video ID (e.g. dQw4w9WgXcQ) to embed in the listing lightbox
   */
  youtubeVideoId?: string | null;
  /**
   * Instagram post or profile URL for this listing
   */
  instaUrl?: string | null;
  /**
   *
   */
  isActive: boolean;
  /**
   *
   */
  isTopAdvert: boolean;
  /**
   *
   */
  isFeaturedAdvert: boolean;
  /**
   *
   */
  createDate: ISODateTime;
  /**
   *
   */
  updateDate: ISODateTime;
  /**
   *
   */
  postalCodeLat?: number | null;
  /**
   *
   */
  postalCodeLong?: number | null;
  /**
   *
   */
  sellerId: number;
  /**
   *
   */
  sellerSlug: string;
  /**
   *
   */
  sellerDisplayName: string;
  /**
   *
   */
  sellerPhotoKey?: string | null;
  /**
   * Agent's personal profile picture URL stored in Vercel Blob
   */
  sellerProfilePictureUrl?: string | null;
  /**
   *
   */
  sellerMemberSince?: string | null;
  /**
   *
   */
  sellerCreatedAt?: ISODateTime;
  /**
   *
   */
  sellerUpdatedAt?: ISODateTime;
  /**
   * Seller's Facebook page URL
   */
  sellerFacebookUrl?: string | null;
  /**
   * Seller's Instagram profile URL
   */
  sellerInstagramUrl?: string | null;
  /**
   * Seller's personal or agency website URL
   */
  sellerWebsiteUrl?: string | null;
  /**
   *
   */
  citySlugId: number;
  /**
   *
   */
  citySlug: string;
  /**
   *
   */
  cityName: string;
  /**
   *
   */
  state?: string | null;
  /**
   *
   */
  province?: string | null;
  /**
   *
   */
  country?: string | null;
  /**
   *
   */
  latitude?: string | null;
  /**
   *
   */
  longitude?: string | null;
  /**
   *
   */
  thumbnailUrl?: string | null;
  /**
   *
   */
  images?: Array<ListingDetailsImagesInner> | null;
  /**
   *
   */
  listingStatus: ListingStatus;
}

export enum ListingDetailsTransactionTypeEnum {
  NEW = 'new',
  RESALE = 'resale',
}
export enum ListingDetailsOwnershipTypeEnum {
  FREEHOLD = 'freehold',
  LEASEHOLD = 'leasehold',
  CO_OP = 'co-op',
}
export enum ListingDetailsFacingDirectionEnum {
  NORTH = 'North',
  EAST = 'East',
  SOUTH = 'South',
  WEST = 'West',
  NORTH_EAST = 'North-East',
  NORTH_WEST = 'North-West',
  SOUTH_EAST = 'South-East',
  SOUTH_WEST = 'South-West',
}
